import { Megaphone, Target, Users } from "lucide-react";
import type { CampaignBriefV1 } from "@runcheetah/shared";

import { Badge } from "@runcheetah/ui";

export function CampaignOverviewSection({ campaignBrief }: { campaignBrief: CampaignBriefV1 }) {
  return (
    <section className="border-b border-border/60 pb-8">
      <div className="mb-5 text-sm uppercase tracking-[0.18em] text-foreground/52">
        Campaign Overview
      </div>
      <div className="grid gap-10 xl:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]">
        <div className="space-y-6">
          <div className="space-y-3">
            <div className="flex items-center gap-2 text-sm font-medium text-foreground">
              <Target className="h-4 w-4 text-foreground/55" aria-hidden="true" />
              Brief
            </div>
            <div className="flex flex-wrap gap-2">
              {campaignBrief.goals.map((goal) => (
                <Badge key={goal.label} variant="secondary" className="text-[11px]">
                  {goal.label}
                </Badge>
              ))}
            </div>
          </div>

          <div className="space-y-3 border-t border-border/60 pt-4">
            <div className="flex items-center gap-2 text-sm font-medium text-foreground">
              <Megaphone className="h-4 w-4 text-foreground/55" aria-hidden="true" />
              CTA Directions
            </div>
            <p className="max-w-3xl text-[15px] leading-7 text-foreground/72">
              {campaignBrief.callToActions.length > 0
                ? campaignBrief.callToActions.join("; ")
                : "No CTA direction has been defined yet."}
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="flex items-center gap-2 text-sm font-medium text-foreground">
            <Users className="h-4 w-4 text-foreground/55" aria-hidden="true" />
            Audience Segments
          </div>
          {campaignBrief.audienceSegments.length > 0 ? (
            <div className="grid gap-x-8 gap-y-5 md:grid-cols-2">
              {campaignBrief.audienceSegments.map((segment) => (
                <div key={segment.label} className="space-y-1.5 border-b border-border/60 pb-4">
                  <div className="text-[15px] font-medium text-foreground">{segment.label}</div>
                  {segment.description ? (
                    <div className="text-[13px] leading-6 text-foreground/68">
                      {segment.description}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-foreground/68">
              Audience segments will appear here once the campaign brief is finalized.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
